﻿export const container = `flex flex-column flex-grow-1`;
